<header class="section-inset-y header" [ngClass]="cssClass()">
  <div class="container header__inner">
    <div class="header__content">
      <h1 class="h2">
        <small class="text-primary">{{ subTitle() }}</small>
        <span>{{ title() }}</span>
      </h1>
      <p class="text-max-width-xs">
        {{ text() }}
      </p>
      @if (link()) {
        <a [href]="link()" class="button button--primary mt-4">
          <span [innerHTML]="dictionaryPrefix() + '-header-button-tekst' | fromDictionary"></span>
        </a>
      }
      <ng-content></ng-content>
    </div>

    <div class="header__figure">
      <figure class="header__figure__inner">
        @if (imgUrl()) {
          <img [src]="imgUrl()! | resize: 900 : 700 : imgAnchor()" [alt]="title()" />
        }
      </figure>
      @if (graphic(); as graphic) {
        <app-graphics [graphic]="graphic"></app-graphics>
      }
    </div>
  </div>
</header>

<!-- TODO:
maybe cool to make it something like this?
- https://codepen.io/shubniggurath/pen/EmMzpp
- https://codepen.io/daniel-hult/pen/vYYdJXv (voorbeeld is zonder interactie)
- https://www.blobmaker.app/ (poept alleen een svg pad uit, maar kan wel handig zijn)
- border-radius vs clippath performance?
-->
